<template>
  <v-container>
    <v-row>
      <v-col cols="12">
        <v-toolbar dense flat class="transparent">
          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <v-btn v-bind="attrs" v-on="on" icon @click="routeBefore">
                <v-icon>mdi-arrow-left</v-icon>
              </v-btn>
            </template>
            <span>Regresar</span>
          </v-tooltip>

          <v-spacer></v-spacer>

          <v-list class="py-0 transparent text-right">
            <v-list-item two-line>
              <v-list-item-content>
                <v-list-item-title class="font-weight-bold text-h6 mb-1">
                  {{ extension }}
                </v-list-item-title>
                <v-list-item-subtitle>
                  {{ queueName(extension) }}
                </v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
          </v-list>

          <!-- <v-spacer></v-spacer> -->
        </v-toolbar>

        <v-col cols="12">
          <v-row>
            <v-col cols="6" lg="3">
              <v-card outlined>
                <v-card-text>
                  <v-list-item two-line>
                    <v-list-item-content>
                      <v-list-item-title
                        class="text-h5 text-md-h4 font-weight-bold mb-1 secondary--text"
                      >
                        {{ queue.waiting }}
                      </v-list-item-title>
                      <v-list-item-subtitle>
                        Esperando
                      </v-list-item-subtitle>
                    </v-list-item-content>
                  </v-list-item>
                </v-card-text>
              </v-card>
            </v-col>

            <v-col cols="6" lg="3">
              <v-card outlined>
                <v-card-text>
                  <v-list-item two-line>
                    <v-list-item-content>
                      <v-list-item-title
                        class="text-h5 text-md-h4 font-weight-bold mb-1 secondary--text"
                      >
                        {{ queue.answered }}
                      </v-list-item-title>
                      <v-list-item-subtitle>
                        Contestadas
                      </v-list-item-subtitle>
                    </v-list-item-content>
                  </v-list-item>
                </v-card-text>
              </v-card>
            </v-col>

            <v-col cols="6" lg="3">
              <v-card outlined>
                <v-card-text>
                  <v-list-item two-line>
                    <v-list-item-content>
                      <v-list-item-title
                        class="text-h5 text-md-h4 font-weight-bold mb-1 secondary--text"
                      >
                        {{ queue.abandon }}
                      </v-list-item-title>
                      <v-list-item-subtitle>
                        Abandonadas
                      </v-list-item-subtitle>
                    </v-list-item-content>
                  </v-list-item>
                </v-card-text>
              </v-card>
            </v-col>

            <v-col cols="6" lg="3">
              <v-card outlined>
                <v-card-text>
                  <v-list-item two-line>
                    <v-list-item-content>
                      <v-list-item-title
                        class="text-h5 text-md-h4 font-weight-bold mb-1 secondary--text"
                      >
                        {{ queue.servicelevel }}
                      </v-list-item-title>
                      <v-list-item-subtitle>
                        SL
                      </v-list-item-subtitle>
                    </v-list-item-content>
                  </v-list-item>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>
        </v-col>

        <v-col cols="12">
          <v-card outlined>
            <v-card-title class="text-h6">
              <div>
                <div>Agentes: {{ queue.agents }}</div>

                <div>
                  <v-chip outlined small class="mr-2 mb-1">
                    <v-avatar left>
                      <v-icon x-small color="error">mdi-circle</v-icon>
                    </v-avatar>
                    <span>
                      Inválido
                    </span>
                  </v-chip>

                  <v-chip outlined small class="mr-2 mb-1">
                    <v-avatar left>
                      <v-icon x-small color="success">mdi-circle</v-icon>
                    </v-avatar>
                    <span>
                      Libre
                    </span>
                  </v-chip>

                  <v-chip outlined small class="mr-2 mb-1">
                    <v-avatar left>
                      <v-icon x-small color="warning">mdi-circle</v-icon>
                    </v-avatar>
                    <span>
                      Ring
                    </span>
                  </v-chip>

                  <v-chip outlined small class="mr-2">
                    <v-avatar left>
                      <v-icon x-small color="info">mdi-circle</v-icon>
                    </v-avatar>
                    <span>
                      En uso
                    </span>
                  </v-chip>
                </div>
              </div>

              <v-spacer></v-spacer>

              <v-col cols="12" md="auto">
                <v-btn
                  @click="openFormDialog"
                  class="accent shadow-4 px-8"
                  color="success"
                  rounded
                >
                  Agregar
                </v-btn>
              </v-col>
            </v-card-title>

            <v-data-table
              :headers="headersAgent"
              :items="items_agents_active"
              :items-per-page="50"
              :footer-props="{
                'items-per-page-options': [50, 100, 150]
              }"
            >
              <template v-slot:[`item.id`]="{ item }">
                <v-icon x-small :color="colorTr(item.agentstatus)"
                  >mdi-circle</v-icon
                >
              </template>

              <template v-slot:[`item.agent`]="{ item }">
                <v-list-item class="px-0">
                  <v-list-item-content class="d-none d-md-block ml-3">
                    <v-list-item-title
                      class="primary--text text--darken-1 font-weight-medium"
                      v-html="item.agent"
                    ></v-list-item-title>
                    <v-list-item-subtitle
                      v-if="item.agentname"
                      v-html="item.agentname"
                    ></v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
              </template>

              <template v-slot:[`item.agenttimelast`]="{ item }">
                {{
                  item.agenttimelast !== "" ? `${item.agenttimelast} secs` : ""
                }}
              </template>

              <template v-slot:[`item.action`]="{ item }">
                <!-- {{ item }} -->
                <v-hover v-slot:default="{ hover }" v-if="item.ext !== false">
                  <v-tooltip color="blue-grey" top>
                    <template v-slot:activator="{ on }">
                      <v-btn
                        v-on="on"
                        text
                        icon
                        :color="hover ? 'error' : 'error'"
                        @click.stop="connect(item.ext, 0)"
                      >
                        <v-icon>mdi-connection</v-icon>
                      </v-btn>
                    </template>
                    <span>Desconectar de planta</span>
                  </v-tooltip>
                </v-hover>

                <!-- <v-hover
                v-slot:default="{ hover }"
                v-if="item.user_id === null && item.ext !== false"
              >
                <v-tooltip color="blue-grey" top>
                  <template v-slot:activator="{ on }">
                    <v-btn
                      v-on="on"
                      text
                      icon
                      :color="hover ? 'success' : 'success'"
                      @click.stop="connect(item.ext, 1)"
                    >
                      <v-icon>mdi-connection</v-icon>
                    </v-btn>
                  </template>
                  <span>Conectar de planta</span>
                </v-tooltip>
              </v-hover> -->
              </template>
            </v-data-table>
          </v-card>
        </v-col>

        <v-col cols="12">
          <v-card outlined>
            <v-card-title class="text-h6">
              Esperando: {{ channels.length }}
            </v-card-title>

            <v-data-table
              :headers="headersWaiting"
              :items="channels"
              :items-per-page="-1"
              hide-default-footer
            >
              <template v-slot:[`item.id`]="{ item }">
                <v-icon x-small :color="colorTr(item.agentstatus)"
                  >mdi-circle</v-icon
                >
              </template>

              <template v-slot:[`item.wait`]="{ item }">
                <td :class="colorWaiting(item.wait)">{{ item.wait }}</td>
              </template>
            </v-data-table>
          </v-card>
        </v-col>

        <newForm
          v-if="isOpenForm"
          :isActive="isOpenForm"
          :queue="extension"
          @close:dialog="closeFormDialog"
        ></newForm>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import axios from "axios";
import { PbxHttpClient } from "@/services/httpclient";
import newForm from "./newForm.vue";

export default {
  components: {
    newForm
  },

  data() {
    return {
      isOpenForm: false,
      headersAgent: [
        {
          text: "",
          align: "center",
          value: "id",
          width: "10%"
        },
        {
          text: "Agente",
          align: "start",
          value: "agent",
          width: "30%"
        },
        { text: "Llamadas", value: "agentanswer", width: "15%" },
        { text: "Estado", value: "agentstatus", width: "15%" },
        {
          text: "Última",
          value: "agenttimelast",
          sortable: false,
          width: "15%"
        },
        {
          text: "Acciones",
          value: "action",
          width: "15%",
          align: "center",
          sortable: false
        }
      ],
      headersWaiting: [
        {
          text: "Canal",
          align: "start",
          value: "channel",
          width: "70%"
        },
        {
          text: "Tiempo",
          align: "end",
          value: "wait",
          width: "30%"
        }
      ],
      extension: "",
      queue: {},
      items_agents_active: [],
      channels: [],
      interval: "",
      queueItems: []
    };
  },

  created() {
    // this.itemExtension();
    // this.statusQueue();
    this.extension = localStorage.getItem("extension_queue");

    this.getNewDetailsQueue();
    this.getNewDetailsQueue2();
    this.getChannels();
    this.getQueues();

    this.interval = setInterval(() => {
      this.getNewDetailsQueue();
      this.getNewDetailsQueue2();
      this.getChannels();
    }, 6000);
  },

  beforeDestroy() {
    clearInterval(this.interval);
  },

  methods: {
    routeBefore() {
      // this.$router.push({
      //   path: "StatusColas"

      // });
      this.$router.push({ path: "StatusColas", query: { tab: 1 } });
    },

    async getNewDetailsQueue() {
      try {
        const { data } = await PbxHttpClient.get(
          `/manager/queue_details?queue=${this.extension}`
        );
        this.items_agents_active = data.data;
      } catch (err) {
        this.$snotify.error(
          "Hubo un error consultandolas extensiones.",
          "¡Error!"
        );
      }
    },

    async getNewDetailsQueue2() {
      try {
        const { data } = await PbxHttpClient.get(
          `/manager/queue_details2?queue=${this.extension}`
        );
        // console.log("details banner", data.data);
        this.queue = data.data[0];
      } catch (err) {
        this.$snotify.error(
          "Hubo un error consultandolas extensiones.",
          "¡Error!"
        );
      }
    },

    async getChannels() {
      try {
        const response = await PbxHttpClient.get(`/manager/channels?queue=${this.extension}`);
        this.channels = response.data?.data || [];
      } catch (error) {
        console.error("Error fetching channels:", error);
        this.$snotify.error(
          "Hubo un error consultando las extensiones.",
          "¡Error!"
        );
      }
    },

    colorTr(color) {
      const colorMap = {
        "S - Unavailable": "error",
        "D - Unavailable": "error",
        "S - Not in use": "success",
        "D - Not in use": "success",
        "S - Ringing": "warning",
        "D - Ringing": "warning",
        "S - In use": "info",
        "D - In use": "info",
        "S - in call": "info",
        "D - in call": "info"
      };
    
      return colorMap[color] || "bg-red";
    },

    colorWaiting(time) {
      const sub = time.charAt(0);

      if (sub === "0") return "";
      if (sub === "1" || sub === "2") return "warning";
      return "error";
    },

    queueName(queue) {
      const result = this.queueItems.filter((item) => item.number == queue);

      return result[0] ? (result[0].name ? result[0].name : "-") : "-";
    },

    async getQueues() {
      try {
        const { data } = await PbxHttpClient.get("/clients/listQueue");
        this.queueItems = data?.data || [];
      } catch (error) {
        console.error("Error fetching queues:", error);
        this.$snotify.error(
          "No se pudo obtener el listado de colas.",
          "¡Error!"
        );
      } finally {
        this.isLoadingQueueItems = false;
      }
    },

    members(data_members) {
      let array_members = [];
      let name = "";
      let interface_members = "";
      let number_calls = "";
      let status = "";
      let duration_calls = "";

      for (const item_member of data_members) {
        const items = item_member.split(" (");

        // nombre del agente
        name = items[0].trim();

        // interface del agente
        if (item_member.includes("local")) {
          interface_members = items[1].split("@")[1];
        } else {
          interface_members = items[1].split("from")[0];
        }

        // numero de llamadas por agente
        number_calls = item_member
          .split(") has taken")[1]
          .split("calls")[0]
          .trim();

        // estado del agente
        let array_status = item_member.split(") has taken")[0].split(") (");
        status = array_status[array_status.length - 1];

        // duracion de ultima llamada
        if (item_member.includes("last was")) {
          duration_calls = item_member
            .split("(last was")[1]
            .split(" secs ")[0]
            .trim();
        } else {
          duration_calls = "";
        }

        array_members.push({
          name: name,
          interface_members: interface_members.substring(
            0,
            interface_members.length - 1
          ),
          number_calls: number_calls,
          status: status,
          duration_calls: duration_calls
        });
      }

      this.items_agents_active = array_members;
    },

    openFormDialog() {
      this.isOpenForm = true;
    },

    closeFormDialog(data = false) {
      // this.pricingsList = data;
      this.isOpenForm = false;
    },

    // async handleLogoutPlanta(id, name) {
    //   const accessToken = localStorage.getItem("token");

    //   const confirmRequest = await this.$swalconfirm(
    //     "Logout",
    //     `Está seguro de desconectar a ${name}.`
    //   );

    //   if (confirmRequest.isConfirmed) {
    //     axios
    //       .get(`${process.env.VUE_APP_ROOTAPI}/authServer/desconnect/${id}`, {
    //         headers: {
    //           Authorization: `Bearer ${accessToken}`,
    //         },
    //       })
    //       .then((res) => {
    //         if (res.status === 200) {
    //           for (const client of res.data) {
    //             switch (client.codigo) {
    //               case "Command":
    //                 this.$snotify.error(
    //                   `Cola ${client.queue}: ${client.message}`,
    //                   "¡Error!"
    //                 );

    //                 break;

    //               case "Removed":
    //                 this.$store.commit("passport/UPDATE_CONNECTION_AGENT", 0);

    //                 this.$snotify.success(
    //                   `${client.message}`,
    //                   `Cola ${client.queue}`
    //                 );

    //                 break;
    //             }
    //           }
    //         }
    //       })
    //       .catch((error) => {
    //         console.error(error);
    //         this.$snotify.error(
    //           "No se pudo desconectar de la planta.",
    //           "Error"
    //         );
    //       })
    //       .finally(() => {
    //         this.isLoading = false;
    //       });
    //   }
    // },

    async connect(extension, status) {
      this.isLoadingConnect = true;
      // const accessToken = localStorage.getItem("token");

      const payload = {
        queue: this.extension,
        status: status,
        extension: extension
      };

      try {
        const res = await PbxHttpClient.post(
          `/admin/connect_extension`,
          payload
        );

        if (res.status === 200) {
          for (const client of res.data) {
            switch (client.codigo) {
              case "Added":
                this.$snotify.success(
                  `${client.message}`,
                  `Cola ${client.queue}`
                );

                break;

              case "Command":
                this.$snotify.error(
                  `Cola ${client.queue}: ${client.message}`,
                  "¡Error!"
                );

                break;

              case "Removed":
                this.$snotify.success(
                  `${client.message}`,
                  `Cola ${client.queue}`
                );

                break;
            }
          }
        }
      } catch (error) {
        console.error(error);
        this.$snotify.error("Error al conectar a planta.", "Error 500");
      } finally {
        this.isLoadingConnect = false;
      }
    }
  }
};
</script>

<style scoped>
.border-toolbart {
  border-top-left-radius: 20px !important;
  border-top-right-radius: 20px !important;
}
.bg-red {
  background: red !important;
}
.bg-salmon {
  background: #fa8072;
}
</style>
